import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { UnsubscribeEmail } from '@/pages/UnsubscribeEmail/UnsubscribeEmail';
import { APP_LANGUAGES } from '@/stores/global.store';

// `company` carries the sending tenant so the page renders that tenant's Brand instead of the platform
// logo. It is optional: an old link with no company resolves to the platform Brand.
const searchSchema = z.object({
	company: z.string().optional(),
	lang: z.enum(APP_LANGUAGES).optional(),
});

export const Route = createFileRoute('/unsubscribe-email/$email')({
	validateSearch: searchSchema,
	component: UnsubscribeEmail,
});
